




































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import DetailPageLayout from "@/views/warning/components/DetailPageLayout.vue";
import { API_BIS_CATEGORY_TREE, API_BIS_PATENT_LIST, API_BIS_REPORT_STAT } from "@/configs/Apis";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { WARNING_PROJECT_ID, CORE_PATENT_FIELD, WARNING_REPOPRTS } from "@/app-data/warning/warning";
import Ajax from "@/utils/DuduAjax";
import ReportTable from "@/views/report/ReportTable.vue";
import ReportChart from "@/views/report/ReportChart.vue";

import cloneDeep from "lodash/cloneDeep";

import XLSX from "xlsx/xlsx.mini";
import FileSaver from "file-saver";
import { RequestConfig } from "@/types";

@Component({
  components: { ReportChart, ReportTable, DetailPageLayout }
})
export default class Warning extends Vue {
  @Prop({ type: String, required: true })
  treeTitle!: string;

  @Prop({ type: String, required: true })
  bodyTitle!: string;

  @Prop({ type: String, required: true })
  categoryField!: string;

  defaultExpandNodes: Array<number> = [];
  expandNodesMap: Set<number> = new Set<number>();
  currentNodeId: any = null;

  requests: { [k: string]: RequestConfig } = {
    category: {
      api: { url: API_BIS_CATEGORY_TREE + "?UC=1", path: {} },
      loading: false,
      params: () => ({}),
      once: true,
      method: "GET",
      callback: this.loadCategoryTree.bind(this),
      data: []
    },
    countryAndType: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: (function () {
        return cloneDeep(WARNING_REPOPRTS.countryAndTypeModel.definition);
      })(),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {}
    },
    appYear: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: (function () {
        return cloneDeep(WARNING_REPOPRTS.appYearModel.definition);
      })(),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {},
      extra: { model: WARNING_REPOPRTS.appYearModel, chartOption: {} }
    },
    area: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: (function () {
        const config = cloneDeep(WARNING_REPOPRTS.provinceModel.definition);
        delete config.rowDims[0].needTotal;
        (config.rowDims[0] as any).limit = 10;
        return config;
      })(),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {},
      extra: { model: WARNING_REPOPRTS.provinceModel, chartOption: {} }
    },
    ipc: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: cloneDeep(WARNING_REPOPRTS.miniIpcCountModel.definition),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {}
    },
    patentee: {
      api: { url: API_BIS_REPORT_STAT + "?UC=1", path: {} },
      loading: false,
      params: cloneDeep(WARNING_REPOPRTS.patenteeModel.definition),
      method: "POST",
      callback: this.processChartData.bind(this),
      data: {}
    },
    newPubPatents: {
      api: { url: API_BIS_PATENT_LIST + "?UC=1", path: {} },
      loading: false,
      params: () => {
        return Object.assign({ orderBy: "pubDate desc", page: 0, pageSize: 10 }, {
          condition: {
            items: [
              {
                name: "pubDate",
                operator: "NOT_NULL"
              }]
          }
        });
      },
      method: "POST",
      callback: this.processTableData.bind(this),
      data: [],
      patentList: true
    },
    newAuthPatents: {
      api: { url: API_BIS_PATENT_LIST + "?UC=1", path: {} },
      loading: false,
      params: () => {
        return Object.assign({ orderBy: "authDate desc", page: 0, pageSize: 10 }, {
          condition: {
            items: [
              {
                name: "authDate",
                operator: "NOT_NULL"
              }]
          }
        });
      },
      method: "POST",
      callback: this.processTableData.bind(this),
      data: [],
      patentList: true
    },
    corePatents: {
      api: { url: API_BIS_PATENT_LIST + "?UC=1", path: {} },
      loading: false,
      params: () => {
        return Object.assign({ orderBy: "pubDate desc", page: 0, pageSize: 10 }, {
          condition: {
            items: [
              {
                name: CORE_PATENT_FIELD,
                operator: "EQUAL",
                value1: "是"
              }]
          }
        });
      },
      method: "POST",
      callback: this.processTableData.bind(this),
      data: [],
      patentList: true
    }
  };

  get projectId() {
    return WARNING_PROJECT_ID;
  }

  mounted() {
    this.processRequestData();
  }

  processRequestData() {
    const requests = this.requests;
    Object.keys(requests).forEach(name => {
      (async () => {
        const config = requests[name];
        try {
          if (config.once === true && (config as any).__loaded === true) {
            return;
          }
          config.loading = true;
          let params;
          if (typeof config.params === "function") {
            params = (config.params as (this: Vue) => any).call(this as any);
          } else {
            params = config.params;
          }
          params = cloneDeep(params);
          if (!Object.prototype.hasOwnProperty.call(config.api.path, "projectId")) {
            config.api.path.projectId = this.projectId;
          }
          const condition: any = params.condition || {};
          if (!condition.items) {
            condition.items = [];
          }
          if (this.currentNodeId) {
            condition.items.push({
              name: this.categoryField,
              operator: "BELONG_TO",
              value1: this.currentNodeId
            });
          } else {
            condition.items.push({
              name: this.categoryField,
              operator: "NOT_NULL"
            });
          }
          if (config.patentList) {
            params.condition = JSON.stringify(condition);
          } else {
            params.condition = condition;
          }
          const res = await Ajax.queryData(config.api, params, config.method, false, false);
          if (config.callback && typeof config.callback === "function") {
            config.callback.call(this, res, config);
          }
        } finally {
          config.loading = false;
          if (config.once === true) {
            (config as any).__loaded = true;
          }
        }
      })();
    });
  }

  loadCategoryTree(data: Array<any>, config: RequestConfig) {
    const treeData: Array<any> = [];
    const map = new Map<string, any>();
    this.expandNodesMap.clear();
    if (!data || !data.length) {
      config.data = [];
    } else {
      const rootPath = "00000" + this.categoryField.substring(8);
      data.forEach(item => {
        if (item.treeLevel <= 1) {
          return;
        }
        if (item.treePath.indexOf(rootPath) < 0) {
          return;
        }
        let treeItem;
        if (map.has(item.id)) {
          treeItem = map.get(item.id);
          if (isEmptyOrWhiteSpace(treeItem.title)) {
            Object.assign(treeItem, item);
          }
        } else {
          treeItem = { name: item.name, ...item };
          map.set(item.id, treeItem);
        }

        if (item.treeLevel === 2) {
          treeData.push(treeItem);
        } else {
          const pId = item.parentId;
          if (map.has(pId)) {
            const pItem = map.get(pId);
            if (!Object.prototype.hasOwnProperty.call(pItem, "children")) {
              pItem.children = [];
            }
            pItem.children.push(treeItem);
          } else {
            map.set(pId, { children: [treeItem] });
          }
        }
      });
    }
    if (this.expandNodesMap.size) {
      this.expandNodesMap.forEach(value => this.defaultExpandNodes.push(value));
    }
    config.data = treeData;
  }

  processChartData(data: any, config: RequestConfig) {
    config.data = data;
    const model = config.extra?.model;
    if (model) {
      config.extra.chartOption = model.chart(config.params, model.chartOption, data);
    }
  }

  processTableData(res: any, config: RequestConfig) {
    if (res && res.data) {
      config.data = res.data;
    }
  }

  onCategoryNodeClick(data: any) {
    this.currentNodeId = data.id || 0;
  }

  onCategoryNodeExpand(data: any) {
    this.expandNodesMap.add(data.id);
  }

  onCategoryNodeCollapse(data: any) {
    this.expandNodesMap.delete(data.id);
  }

  onCountryChange(value: any) {
    console.log(value);
  }

  exportExcel(tableRef: string, title: string) {
    if (!tableRef) {
      return;
    }
    const elTable: any = this.$refs[tableRef];
    if (!elTable) {
      return;
    }
    const data = elTable.data;
    if (!data) {
      return;
    }
    const columns = elTable.columns;
    if (!columns || !columns.length) {
      return;
    }
    try {
      const headers = columns.map((col: any) => col.label);
      const xlsxParam = { header: headers };
      const newData: Array<any> = [];
      const width: Array<{ wch: number }> = [];
      const baseWidth = 1.5;
      data.forEach((item: any, rowIndex: number) => {
        const dataItem: { [key: string]: any } = {};
        columns.forEach((col: any, colIndex: number) => {
          let value;
          if (col.type === "index") {
            value = (rowIndex + 1).toString();
          } else {
            value = item[col.property]?.toString();
          }
          dataItem[col.label] = value;
          width[colIndex] = { wch: width[colIndex] ? Math.max(width[colIndex].wch, baseWidth * value.length) : baseWidth * value.length };
        });
        newData.push(dataItem);
      });
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(newData, xlsxParam);
      ws["!cols"] = width;
      XLSX.utils.book_append_sheet(wb, ws);
      const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
      FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${title || "export-" + Date.now()}.xlsx`);
    } catch (e) {
      console.error(e);
    }
  }

  @Watch("currentNodeId")
  onCurrentFilterChange() {
    this.processRequestData();
  }
};
